module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/3/1-34af782a8f6c9f99e76bd708ca0dc6f3.jpg";